import {
    ClickAwayListener, Grow, makeStyles, MenuItem, MenuList, Paper, Popper,
} from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import AccountForm from '../../account';

const propTypes = {};
const defaultProps = {};

const styles = makeStyles((theme) => ({
    avatar: {
        // background: 'transparent',
        // border: '1px solid white',
        width: theme.spacing(4),
        height: theme.spacing(4),
    },
    paper: {
        background: theme.palette.dark,
        width: 250,
        color: '#FFF',
    },
}));

function User({ user }) {
    const classes = styles();

    const [open, setOpen] = React.useState(false);
    const [openForm, setOpenForm] = React.useState(false);
    const anchorRef = React.useRef(null);

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        }
    }

    // return focus to the button when we transitioned from !open -> open
    const prevOpen = React.useRef(open);
    React.useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;
    }, [open]);

    const handleToggleForm = () => {
        setOpenForm((prev) => !prev);
    };


    return (
        <div>
            <Button
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                color="primary"
                aria-owns={open ? 'menu-list-grow' : null}
                onClick={handleToggle}
                startIcon={(
                    <Avatar className={classes.avatar}>
                        <Typography variant="body1">{user.first_name.charAt(0)}</Typography>
                    </Avatar>
                )}
            >

                <Typography variant="body1" color="textPrimary">{user.first_name}</Typography>
            </Button>

            <Popper
                transition
                disablePortal
                open={open}
                role={undefined}
                placement="bottom"
                anchorEl={anchorRef.current}
            >
                {({ TransitionProps }) => (
                    <Grow
                        {...TransitionProps}
                        id="menu-list-grow"
                    >
                        <Paper className={classes.paper}>
                            <ClickAwayListener onClickAway={handleClose} onKeyDown={handleListKeyDown}>
                                <MenuList>
                                    <MenuItem onClick={handleToggleForm}>
                                        Profile
                                    </MenuItem>
                                    <MenuItem>
                                        Logout
                                    </MenuItem>
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>


            <AccountForm
                open={openForm}
                onToggleFormClick={handleToggleForm}
            />
        </div>
    );
}

User.propTypes = propTypes;
User.defaultProps = defaultProps;

export default User;
